import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export interface PageHeaderProps {
  title: ReactNode;
  /** One-line context under the title. */
  description?: ReactNode;
  /** Right-aligned slot on the title row (buttons, filters). */
  actions?: ReactNode;
  /** Small uppercase kicker above the title (e.g. case name, section). */
  eyebrow?: ReactNode;
  /** 'section' (20px — default, matches page-level chrome) · 'title' (28px). */
  size?: 'section' | 'title';
  className?: string;
}

export default function PageHeader({
  title,
  description,
  actions,
  eyebrow,
  size = 'section',
  className,
}: PageHeaderProps) {
  return (
    <header className={cn('mb-6 flex items-start justify-between gap-4', className)}>
      <div className="min-w-0">
        {eyebrow && <p className="t-eyebrow mb-1">{eyebrow}</p>}
        <h1 className={cn(size === 'title' ? 't-title' : 't-section', 'text-green-900')}>{title}</h1>
        {description && <p className="t-body mt-1 text-ink-faint">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
    </header>
  );
}
